(ns pfo.widget.timepicker
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.util :as util :refer [reset-from-event]]
            [cljs-time.format :as time-format]
            [cljs-time.coerce :as time-coerce]
            [cljs-time.core :as time-core]
            [pfo.time :refer [now-js-date]]
            [clojure.string :as str :refer [trim ends-with?]]))

(def $ js/$)

(defn get-default-start-time []
  (let [current-time (now-js-date)]
    (when (and (not= 0 (.getMinutes current-time)) (not= 23 (.getHours current-time)))
      (.setHours current-time (+ 1 (.getHours current-time))))
    (.setMinutes current-time 0)
    (.setSeconds current-time 0)
    (.setMilliseconds current-time 0)
    current-time))

(defn datetimepair [options]
  (let [show-time-picker (if-not (contains? options :show-time-picker) true (:show-time-picker options))
        start-time-atom (:start-time-atom options)
        end-time-atom (:end-time-atom options)
        elem-node (atom nil)]
    (reagent/create-class
      {:reagent-render (fn [options]
                         [:div.u-flex.u-flex--wrap.o-margin-elements--medium {:key (:key options) :ref #(reset! elem-node %)}

                          [:div
                           [:label.u-block "Start Date"]
                           [:input.date.start {:type "text"}]]

                          (when show-time-picker
                            [:div
                             [:label.u-block "Start Time"]
                             [:input.time.start {:type "text"}]])

                          [:label.u-flex__self-align-center.u-margin-top--lg "To"]

                          [:div
                           [:label.u-block "End Date"]
                           [:input.date.end {:type "text"}]]

                          (when show-time-picker
                            [:div
                             [:label.u-block "End Time"]
                             [:input.time.end {:type "text"}]])])

       :component-did-mount (fn [_]
                              (let [elem ($ @elem-node)
                                    start-date-elem (.find elem ".date.start")
                                    start-time-elem (.find elem ".time.start")
                                    end-date-elem (.find elem ".date.end")
                                    end-time-elem (.find elem ".time.end")
                                    get-date-time (fn [date-elem time-elem]
                                                    (let [datetime (.datepicker date-elem "getDate")
                                                          atime (.timepicker time-elem "getTime")]
                                                      (when show-time-picker
                                                        (.setHours datetime (.getHours atime))
                                                        (.setMinutes datetime (.getMinutes atime)))
                                                      datetime))]
                                (.timepicker (.find elem ".time") (clj->js {:showDuration true
                                                                            :timeFormat "g:ia"}))
                                (.datepicker (.find elem ".date") (clj->js {:format "m/d/yyyy"
                                                                            :clearBtn true
                                                                            :autoclose true}))

                                (js/Datepair. @elem-node #js{"anchor" nil})
                                (when (and start-time-atom @start-time-atom)
                                  (.on start-date-elem "clearDate" (fn [ev]
                                                                     (reset! start-time-atom nil)))
                                  (.on end-date-elem "clearDate" (fn [ev]
                                                                   (reset! end-time-atom nil)))
                                  (.trigger (.datepicker start-date-elem "setDate" @start-time-atom) "change")
                                  (.trigger (.timepicker start-time-elem "setTime" @start-time-atom) "change"))
                                (when (and end-time-atom @end-time-atom)
                                  (.trigger (.datepicker end-date-elem "setDate" @end-time-atom) "change")
                                  (.trigger (.timepicker end-time-elem "setTime" @end-time-atom) "change"))
                                (.on elem "rangeSelected"
                                     (fn [ev]
                                       (reset! start-time-atom (get-date-time start-date-elem start-time-elem))
                                       (reset! end-time-atom (get-date-time end-date-elem end-time-elem))))
                                (when-not (and end-time-atom @end-time-atom)
                                  (.trigger elem "rangeSelected"))))})))

(defn datetimepicker [{:keys [cljs-time] :as options}]
  (let [show-time-picker (if-not (contains? options :show-time-picker) true (:show-time-picker options))
        time-atom (:time-atom options)
        get-atom-time #(if cljs-time (time-coerce/to-date @time-atom) @time-atom)
        set-atom-time! #(reset! time-atom (if cljs-time (time-coerce/from-date %) %))
        skip-update (clojure.core/atom false)
        elem-node (atom nil)]
    (reagent/create-class     {:reagent-render (fn [options]
                         (identity @time-atom)
                         [:span.picker  {:key (:key options) 
                                        :ref #(reset! elem-node %)
                                        :class (when (:green-box options) "u-border--green-rounded--thin")}
                          [:input.date.datetime {:type "text"}] " "
                          (when show-time-picker
                            [:input.time.datetime {:type "text"}])])
       :component-did-mount (fn [_]
                              (let [elem ($ @elem-node)
                                    date-elem (.find elem ".date")
                                    time-elem (.find elem ".time")
                                    get-date-time (fn [date-elem time-elem]
                                                    (let [datetime (.datepicker date-elem "getDate")
                                                          atime (.timepicker time-elem "getTime")]
                                                      (when show-time-picker (do 
                                                                               (.setHours datetime (.getHours atime))
                                                                               (.setMinutes datetime (.getMinutes atime))))
                                                      datetime))]
                                (.timepicker (.find elem ".time") (clj->js {:showDuration true
                                                                            :timeFormat "g:ia"}))
                                (.datepicker (.find elem ".date") (clj->js {:format "m/d/yyyy"
                                                                            :clearBtn true
                                                                            :autoclose true}))
                                (when (and time-atom @time-atom)
                                  (do 
                                    (.datepicker date-elem "setDate" (get-atom-time))
                                    (.timepicker time-elem "setTime" (get-atom-time))))
                                (.on date-elem "clearDate" (fn [ev]
                                                             (set-atom-time! nil)))
                                (.on (.find elem ".datetime") #(set-atom-time! (get-date-time date-elem time-elem)))
                                (.on elem "changeDate"
                                     (fn [ev]
                                       (when-not @skip-update
                                         (set-atom-time! (get-date-time date-elem time-elem)))))))
       :component-did-update (fn [_]
                               (let [elem ($ @elem-node)
                                     date-elem (.find elem ".date")
                                     time-elem (.find elem ".time")]
                                 (when (and time-atom @time-atom)
                                   (do
                                     (reset! skip-update true)
                                     (.datepicker date-elem "setDate" (get-atom-time))
                                     (.timepicker time-elem "setTime" (get-atom-time))
                                     (reset! skip-update false)))))})))

(defn hour-minute-picker [options]
  (let [hour-atom (:hour-atom options)
        minute-atom (:minute-atom options)
        time-atom (atom (when (and @hour-atom @minute-atom) 
                          (time-format/unparse (time-format/formatter "HH:mm") (time-core/date-time 0000 00 0 @hour-atom @minute-atom))))
        elem-node (atom nil)
        parse-time (fn [time-str]
                     (if-let [time-str (util/to-value (trim time-str))]
                       (let [[hour minute] (util/split-string time-str #":")
                             hour (util/str->int hour)
                             minute (util/str->int minute)]
                         (if (ends-with? time-str "pm")
                           (if (= hour 12)
                             [hour minute]
                             [(+ hour 12) minute])
                           (if (= hour 12)
                             [0 minute]
                             [hour minute])))
                       [nil nil]))
        update-hour-minute (fn []
                             (let [[hour minute] (parse-time @time-atom)]
                               (reset! hour-atom hour)
                               (reset! minute-atom minute)))]
    (reagent/create-class
     {:reagent-render (fn [options]
                        [:div.u-flex.u-flex--wrap.o-margin-elements--medium {:key (:key options) :ref #(reset! elem-node %)}
                         [:div
                          [:input.time {:type "text"}]]])

      :component-did-mount (fn [_]
                             (let [elem ($ @elem-node)
                                   time-elem (.find elem ".time")]
                               (.timepicker (.find elem ".time") (clj->js {:showDuration true
                                                                           :timeFormat "g:ia"}))
                               (js/Datepair. @elem-node #js{"anchor" nil})
                               (.on time-elem "change"
                                    (fn [ev]
                                      ((reset-from-event time-atom) ev)
                                      (update-hour-minute)))
                               (when (and time-atom @time-atom)
                                 (.trigger (.timepicker time-elem "setTime" @time-atom) "change"))))})))